/* ActionsComponent.js */

"use strict";

const BaseActivityViewColumnComponent = require("../BaseActivityViewColumnComponent");
const Renderer = require("./ActionsRenderer");
const _ = require("lodash");

class ActionsColumnComponent extends BaseActivityViewColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._activityEntity = activityEntity;
        const normalizedActivity = this._normalizeActivity(activityEntity);
        this._delete = _.get(normalizedActivity, "actions.delete", false);
        this._edit = _.get(normalizedActivity, "actions.edit", false);
        this._viewMore = _.get(normalizedActivity, "actions.viewMore", false);
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
            this._delete = undefined;
            this._edit = undefined;
            this._viewMore = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _triggerUserCellAction(eventData) {
        this.emit("UserCellAction", eventData);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.delete)) {
            this.setDelete(newVal.delete);
        }
        if (!_.isUndefined(newVal.edit)) {
            this.setEdit(newVal.edit);
        }
        if (!_.isUndefined(newVal.viewMore)) {
            this.setViewMore(newVal.viewMore);
        }
    }

    getValue() {
        return {
            delete: this.getDelete(),
            edit: this.getEdit(),
            viewMore: this.getViewMore()
        };
    }

    setDelete(newVal) {
        this._delete = newVal;
        this.emit("Delete", newVal);
        return this;
    }

    getDelete() {
        return this._delete;
    }

    setEdit(newVal) {
        this._edit = newVal;
        this.emit("Edit", newVal);
        return this;
    }

    getEdit() {
        return this._edit;
    }

    setViewMore(newVal) {
        this._viewMore = newVal;
        this.emit("ViewMore", newVal);
        return this;
    }

    getViewMore() {
        return this._viewMore;
    }

    getAllLogs(jobId) {
        let fields = {};
        return this._activityEntity.loadLog(this._activityEntity._tenantId, jobId, fields).then((JobLogEntity) => {
            let logs = JobLogEntity.logs;
            //eventType: "FINISH"
            let endOfLogs = logs.some(function (log) {
                return log.eventType && log.eventType === "FINISH";
            });
            endOfLogs = endOfLogs || _.get(logs[0], "msg", "").startsWith("Job failed with:");
            if (!endOfLogs) {
                _.delay(() => this.emit("UpdateTooltip"), 2000);
            }
            return logs;
        });
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ActionsColumnComponent;
